import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { 
    createProductCategory, 
    updateProductCategory, 
    deleteProductCategory, 
    deleteProductCategoryById,
    getProductCategoryList, 
    productCategoryList,
    productCategoryEditView,
    createProduct,
    updateProduct,
    getProductById,
    getProductsList,
    deleteProduct
} from "../api/products";

export const useGetProductCategories = () => {
    return useQuery({
        queryKey: ['productCategories'],
        queryFn: getProductCategoryList,
    });
}

export const useCreateProductCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createProductCategory'],
        mutationFn: ({ data, image, toast, navigate }) => createProductCategory(data, image, toast, navigate),
        onSuccess: () => {
            queryClient.invalidateQueries(['productCategories']);
        },
    });
}

export const useUpdateProductCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateProductCategory'],
        mutationFn: ({ id, data, image, toast, navigate }) => updateProductCategory(id, data, image, toast, navigate),
        onSuccess: () => {
            queryClient.invalidateQueries(['productCategories']);
        },
    });
}

export const useDeleteProductCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteProductCategory'],
        mutationFn: (id) => deleteProductCategoryById(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['productCategories']);
        },
    });
}

export const useGetProductCategoryById = (id, data, setData, setActive, setImage, toast) => {
    return useQuery({
        queryKey: ['productCategory', id],
        queryFn: () => productCategoryEditView(id, data, setData, setActive, setImage, toast),
        enabled: !!id,
    });
}

// ==================== PRODUCT/SERVICE HOOKS ====================

export const useCreateProduct = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createProduct'],
        mutationFn: ({ data, logo, additionalImages, toast, navigate }) => createProduct(data, logo, additionalImages, toast, navigate),
        onSuccess: () => {
            queryClient.invalidateQueries(['products']);
        },
    });
}

export const useGetProductById = (id) => {
    return useQuery({
        queryKey: ['product', id],
        queryFn: () => getProductById(id),
        enabled: !!id,
    });
}

export const useUpdateProduct = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateProduct'],
        mutationFn: ({ id, data, logo, additionalImages, toast, navigate }) => updateProduct(id, data, logo, additionalImages, toast, navigate),
        onSuccess: () => {
            queryClient.invalidateQueries(['products']);
            queryClient.invalidateQueries(['product']);
        },
    });
}

export const useGetProductsList = () => {
    return useQuery({
        queryKey: ['products'],
        queryFn: getProductsList,
    });
}

export const useDeleteProduct = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['deleteProduct'],
        mutationFn: ({ id, toast }) => deleteProduct(id, toast),
        onSuccess: () => {
            queryClient.invalidateQueries(['products']);
        },
    });
}
